<form class="flex flex-wrap gap-4" [formGroup]="rootForm">
  @if (scopeForms$ | async; as scopeForms) {
    @if (rootForm.controls[scopeForms.brand.scopeId]; as brandForm) {
      <mat-form-field
        subscriptSizing="dynamic"
        [formGroupName]="scopeForms.brand.scopeId"
      >
        <mat-label>Select a brand</mat-label>
        <mat-select formControlName="brandRef" required>
          @for (
            brand of scopeForms.brand.options$ | async;
            track brand.ref.path
          ) {
            <mat-option [value]="brand.ref">
              {{ brand.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (rootForm.controls[scopeForms.practice.scopeId]; as practiceForm) {
      <mat-form-field
        subscriptSizing="dynamic"
        [formGroupName]="scopeForms.practice.scopeId"
      >
        <mat-label>Select practices</mat-label>
        <mat-select formControlName="practiceRefs" required multiple>
          @for (
            practice of scopeForms.practice.options$ | async;
            track practice.ref.path
          ) {
            <mat-option [value]="practice.ref">
              {{ practice.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }
</form>
